angular.module('picmonicng').directive('sharedPlaylistLink', [
  '$modal',
  function ($modal) {
    return {
      restrict: 'A',
      scope: {
        playlist: '=',
      },
      link: function (scope, element, attrs) {
        element.bind('click', function (event) {
          scope.$apply(function () {
            $modal.open({
              templateUrl: '/templates/modals/shared-playlist-link.html',
              backdrop: true,
              controller: [
                '$scope',
                '$modalInstance',
                'User',
                'Playlists',
                'UserService',
                function ($scope, $modalInstance, User, Playlists, UserService) {
                  $scope.loading = true;
                  $scope.playlist = scope.playlist;

                  send_ga('event', 'Playlist', 'Share Playlist Link');

                  Playlists.savev3(
                    {
                      playlist_id: scope.playlist.playlist_id,
                      type: 'public',
                      resource: 'shares',
                    },
                    function (data) {
                      $('.sharedPlaylistLink')
                        .val(
                          window.location.protocol +
                            '//' +
                            window.location.host +
                            '/playlists/' +
                            data.share_key +
                            '?' +
                            UserService.getReferralParam()
                        )
                        .show()
                        .focus()
                        .select();
                    }
                  );

                  $scope.close = function () {
                    $modalInstance.close();
                  };
                },
              ],
            });
          });
        });
      },
    };
  },
]);
